module.exports = __webpack_public_path__ + "img/gzh.756f6f4c.jpg";